// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

// Components
import TriageList from 'modules/triage/triage-list';
import SVG from 'components/widgets/icons/svg';

// Constants
import { rightPaneWidth, isMobile } from 'constants';


class RightPane extends React.Component {
  static propTypes = {
    layout: PropTypes.object,
    user: PropTypes.object,
    closeRightPane: PropTypes.func.isRequired,
    openRightPane: PropTypes.func.isRequired,
    closingRightPane: PropTypes.func.isRequired
  };

  constructor() {
    super();

    this.collapsePane = this.collapsePane.bind(this);
    this.switchTab = this.switchTab.bind(this);
  }

  collapsePane() {
    this.props.closeRightPane();
  }

  switchTab(tab) {
    this.props.openRightPane(tab);
  }

  render() {
    const { closeRightPane, layout: { position, collapsed } } = this.props;
    const style = {};
    const paneOpen = position === 0;

    if (position === rightPaneWidth) style.boxShadow = 'none';
    if (isMobile) style.transform = `translate3d(${position}px, 0, 0)`;

    return (
      <div style={style} id="right-pane" className={classNames({ open: paneOpen, collapsed })}>
        <div className="tab-header">
          <SVG src="svg/triage.svg" className="triage" />
          <span className="tab-header-title">Triage</span>
          { isMobile && <SVG src="svg/close.svg" onClick={closeRightPane} /> }
        </div>

        <div className="tab-contents">
          <TriageList />
        </div>
      </div>
    );
  }
}


// Internal methods
function mapStateToProps(state) {
  return {
    layout: state.layout.rightPane,
    user: state.auth.currentUser
  };
}


// Exports
export default connect(mapStateToProps)(RightPane);



// WEBPACK FOOTER //
// ./app/components/right-pane/right-pane.js